import Back from "components/Back/Back";
import styles from "./TransactionDetails.module.scss";
import logoDark from "assets/icons/logoDark.svg";
import DashboardLayout from "layout/Dashboard/DashboardLayout";
import classNames from "classnames";
import { useParams } from "react-router-dom";
import { useContext, useEffect } from "react";
import { TransactionContext } from "context/TransactionContext";
import { useAppSelector } from "app/hooks";
import { formatCurrency, formatDate } from "utils/formatter";
import MyLoader from "components/Loader/Loader";
import { calculateFee } from "utils/calculateFee";

function TransactionDetails() {
  const { id } = useParams();
  const { fetchTransaction } = useContext(TransactionContext);
  const { transaction, transLoading } = useAppSelector(
    (state) => state.transactions,
  );
  useEffect(() => {
    if (id) fetchTransaction(id);
    // eslint-disable-next-line
  }, [id]);

  // useEffect(() => {
  //   if (transaction?.totalAmount)
  //     calculateFlutterCharge(transaction.totalAmount);
  // }, [transaction, calculateFlutterCharge]);

  return (
    <DashboardLayout
      breadcrumb="Transactions"
      breadcrumbLink="transactions"
      title="Transactions"
      center
    >
      <Back />
      {transLoading ? (
        <MyLoader />
      ) : (
        <>
          <div className={styles.transactionDetails}>
            <div className={styles.center}>
              <img src={logoDark} alt="pawa360" className={styles.logo} />
              <p>
                {transaction?.createdAt &&
                  formatDate({ val: transaction?.createdAt, fullDate: true })}
              </p>
            </div>
            {transaction?.token ? (
              <div className={styles.token}>
                <h3>{transaction?.token}</h3>
              </div>
            ) : (
              <div className={styles.token}>
                <h5 style={{ fontSize: "14px" }}>
                  No token generated. Please, contact Support.
                </h5>
              </div>
            )}
            {/* {transaction?.meterType === "Prepaid" ? (
              transaction?.token ? (
                <div className={styles.token}>
                  <h3>{transaction?.token}</h3>
                </div>
              ) : (
                <div className={styles.token}>
                  <h5 style={{ fontSize: "14px" }}>
                    No token generated. Please, contact Support.
                  </h5>
                </div>
              )
            ) : (
              <div className={styles.token}>
                <h5 style={{ fontSize: "14px" }}>Postpaid message</h5>
              </div>
            )} */}
            {/* <div className={classNames([styles.flexRow, styles.item])}>
              <p className={styles.title}>Token Type</p>
              <p className={styles.text}>Credit</p>
            </div> */}
            <div className={classNames([styles.item])}>
              <div className={classNames([styles.flexRow])}>
                <p className={styles.title}>Customer Name</p>
                <p className={styles.text}>{transaction?.customerName}</p>
              </div>
              {/* <div className={classNames([styles.flexRow])}>
                <p className={styles.title}>Customer Type</p>
                <p className={styles.text}>R3</p>
              </div> */}
              <div className={classNames([styles.flexRow])}>
                <p className={styles.title}>Address</p>
                <p className={styles.text}>{transaction?.customerAddress}</p>
              </div>
            </div>
            <div className={classNames([styles.flexRow, styles.item])}>
              <p className={styles.title}>Meter Number</p>
              <p className={styles.text}>{transaction?.meterNumber}</p>
            </div>
            <div className={classNames([styles.item])}>
              {transaction?.meterType?.toLocaleLowerCase() === "prepaid" && (
                <div className={classNames([styles.flexRow])}>
                  <p className={styles.title}>Unit value</p>
                  <p className={styles.text}>
                    {transaction?.units && transaction?.units} units
                  </p>
                </div>
              )}
            </div>
            <div className={classNames([styles.item])}>
              <div className={classNames([styles.flexRow])}>
                <p className={styles.title}>Electricity Amount</p>
                <p className={styles.text}>
                  {transaction.currency}{" "}
                  {transaction?.totalAmount &&
                    formatCurrency(transaction?.totalAmount.toString())}
                </p>
              </div>
              <div className={classNames([styles.flexRow])}>
                <p className={styles.title}>VAT</p>
                <p className={styles.text}>
                  NGN{" "}
                  {transaction?.totalAmount &&
                    formatCurrency(transaction?.totalAmount.toString())}
                </p>
              </div>
              {/* <div className={classNames([styles.flexRow])}>
                <p className={styles.title}>Processing fee</p>
                <p className={styles.text}>
                NGN{" "}
                  {transaction?.totalAmount &&
                    formatCurrency(
                      calculateFlutterCharge(transaction?.totalAmount).toString()
                    )}
                </p>
              </div> */}
              <div className={classNames([styles.flexRow])}>
                <p className={styles.title}>Service charge</p>
                <p className={styles.text}>
                  {" "}
                  {calculateFee(transaction?.totalAmount)}
                </p>
              </div>
              <div className={classNames([styles.flexRow])}>
                <p className={styles.title}>Total</p>
                <p className={styles.text}>
                  {" "}
                  NGN{" "}
                  {transaction?.totalAmount &&
                    formatCurrency(transaction?.totalAmount.toString())}
                </p>
              </div>
            </div>

            <div className={classNames([styles.flexRow])}>
              <p className={styles.title}>Operator</p>
              <p className={styles.text}>Pawa360</p>
            </div>
            <p className={styles.bottomText}>
              Thank you for your purchase.
            </p>
            <div className={styles.center}>
              <img src={logoDark} alt="pawa360" className={styles.logo} />
            </div>
          </div>
          {/* <div className={styles.btnContainer}>
            <Button text="Send to Email" color="dark" disabled />
            <Button text="Download" color="dark" />
          </div> */}
        </>
      )}
    </DashboardLayout>
  );
}

export default TransactionDetails;
